import axios from 'axios'
export default {
    login(data) {
        return axios({
            url: '/login',
            method: 'post',
            data: data,
        })
            .then((res) => res)
            .catch((err) => err)
    },
    //登出
    logout(params) {
        return axios({
            url: '/user/logout',
            method: 'get',
            params
        })
            .then((res) => res)
            .catch((err) => err)
    },
    add(data) {
        return axios({
            url: '/employee',
            method: 'post',
            data
        })
            .then((res) => res)
            .catch((err) => err)
    },
    edit(data) {
        return axios({
            url: '/employee/' + data.id,
            method: 'post',
            data
        })
            .then((res) => res)
            .catch((err) => err)
    },
    subjectList() {
        return axios({
            url: '/subject',
            method: 'get',
        })
            .then((res) => res)
            .catch((err) => err)
    },
    gradeList() {
        return axios({
            url: '/grade',
            method: 'get',
        })
            .then((res) => res)
            .catch((err) => err)
    },
    subjectByIdList(params) {
        return axios({
            url: '/subject/getSubjectbyEmp',
            method: 'get',
            params
        })
            .then((res) => res)
            .catch((err) => err)
    },
    gradeByIdList(params) {
        return axios({
            url: '/grade/getGradeBySubjectId',
            method: 'get',
            params
        })
            .then((res) => res)
            .catch((err) => err)
    },
    getActiveList() {
        return axios({
            url: '/active',
            method: 'get',
        })
            .then((res) => res)
            .catch((err) => err)
    },
    pwd(data) {
        return axios({
            url: '/pwd',
            method: 'post',
            data
        })
            .then((res) => res)
            .catch((err) => err)
    },
    getGradeList() {
        return axios({
            url: '/sys/dicts/grade/items',
            method: 'get',
        })
            .then((res) => res)
            .catch((err) => err)
    },
}